import { connect } from 'react-redux';
import TambahTahunAjaran from '../../../views/Akademi/DataKelas/TambahTahunAjaran.view';
import {
  savePeriods, listPeriods, editPeriods, editPeriodsAllUnit, getPeriods,
} from '../../../states/thunks/academics.thunk';
import { getSchoolUnitsOptions } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetPeriods: payload => dispatch(getPeriods(payload)),
    handleSavePeriods: (payload, goback) => dispatch(savePeriods(payload, goback)),
    handleListPeriods: (payload, goback) => dispatch(listPeriods(payload, goback)),
    handleEditPeriods: (payload, goback) => dispatch(editPeriods(payload, goback)),
    handleEditPeriodsAllUnit: (payload, goback) => dispatch(editPeriodsAllUnit(payload, goback)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TambahTahunAjaran);
